module.exports = __webpack_public_path__ + "media/images/flags/1x1/omn-9aab94608f933e7fc32e7ef4981ac009.svg";